
import { EstadoType } from "curp-ts";

interface Props{
    clave:          string;
    descripcion:    string;
    type:           EstadoType;
}

export const ObtenerClaveEntidad = ( descripcion: string ) => {     
    
    const entidades_federativas: Props[] = [
        { descripcion: 'Aguascalientes', clave: 'AS' , type: 'AS' },
        { descripcion: 'Baja California', clave:  'BC', type:  'BC' },
        { descripcion: 'Baja California Sur', clave:  'BS', type:  'BS' },
        { descripcion: 'Campeche', clave:  'CC', type:  'CC' },
        { descripcion: 'Coahuila de Zaragoza', clave:  'CL', type:  'CL' },
        { descripcion: 'Colima', clave:  'CM', type:  'CM' },
        { descripcion: 'Chiapas', clave:  'CS', type:  'CS' }, 
        { descripcion: 'Chihuahua', clave:  'CH', type:  'CH' },
        { descripcion: 'Ciudad de México', clave:  'DF', type:  'DF' },
        { descripcion: 'Durango', clave:  'DG', type:  'DG' },
        { descripcion: 'Guanajuato', clave:  'GT', type:  'GT' }, 
        { descripcion: 'Guerrero', clave:  'GR', type:  'GR' },
        { descripcion: 'Hidalgo', clave:  'HG', type:  'HG' },
        { descripcion: 'Jalisco', clave:  'JC', type:  'JC' },
        { descripcion: 'México', clave:  'MC', type:  'MC' }, 
        { descripcion: 'Michoacán de Ocampo', clave:  'MN', type:  'MN' },
        { descripcion: 'Morelos', clave:  'MS', type:  'MS' }, 
        { descripcion: 'Nayarit', clave:  'NT', type:  'NT' },
        { descripcion: 'Nuevo León', clave:  'NL', type:  'NL' }, 
        { descripcion: 'Oaxaca', clave:  'OC', type:  'OC' },
        { descripcion: 'Puebla', clave:  'PL', type:  'PL' },
        { descripcion: 'Querétaro', clave:  'QT', type:  'QT' },
        { descripcion: 'Quintana Roo', clave:  'QR', type:  'QR' }, 
        { descripcion: 'San Luis Potosí', clave:  'SP', type:  'SP' },
        { descripcion: 'Sinaloa', clave:  'SL', type:  'SL' }, 
        { descripcion: 'Sonora', clave:  'SR', type:  'SR' },
        { descripcion: 'Tabasco', clave:  'TC', type:  'TC' }, 
        { descripcion: 'Tamaulipas', clave:  'TS', type:  'TS' },
        { descripcion: 'Tlaxcala', clave:  'TL', type:  'TL' }, 
        { descripcion: 'Veracruz de Ignacio de la Llave', clave:  'VZ', type:  'VZ' },
        { descripcion: 'Yucatán', clave:  'YN', type:  'YN' }, 
        { descripcion: 'Zacatecas', clave:  'ZS', type:  'ZS' }
    ];
    
    const entidad_federativa = entidades_federativas.find( element => { return element.descripcion === descripcion });

    return entidad_federativa;
}

export const ObtenerDescripcionEntidad = ( clave: string ) => {     
    
    const entidades_federativas = [
        { estado: 'Aguascalientes', clave: 'AS' },
        { estado: 'Baja California', clave:  'BC' },
        { estado: 'Baja California Sur', clave:  'BS' },
        { estado: 'Campeche', clave:  'CC' },
        { estado: 'Coahuila de Zaragoza', clave:  'CL' },
        { estado: 'Colima', clave:  'CM' },
        { estado: 'Chiapas', clave:  'CS' }, 
        { estado: 'Chihuahua', clave:  'CH' },
        { estado: 'Ciudad de México', clave:  'DF' },
        { estado: 'Durango', clave:  'DG' },
        { estado: 'Guanajuato', clave:  'GT' }, 
        { estado: 'Guerrero', clave:  'GR' },
        { estado: 'Hidalgo', clave:  'HG' },
        { estado: 'Jalisco', clave:  'JC' },
        { estado: 'México', clave:  'MC' }, 
        { estado: 'Michoacán de Ocampo', clave:  'MN' },
        { estado: 'Morelos', clave:  'MS' }, 
        { estado: 'Nayarit', clave:  'NT' },
        { estado: 'Nuevo León', clave:  'NL' }, 
        { estado: 'Oaxaca', clave:  'OC' },
        { estado: 'Puebla', clave:  'PL' },
        { estado: 'Querétaro', clave:  'QT' },
        { estado: 'Quintana Roo', clave:  'QR' }, 
        { estado: 'San Luis Potosí', clave:  'SP' },
        { estado: 'Sinaloa', clave:  'SL' }, 
        { estado: 'Sonora', clave:  'SR' },
        { estado: 'Tabasco', clave:  'TC' }, 
        { estado: 'Tamaulipas', clave:  'TS' },
        { estado: 'Tlaxcala', clave:  'TL' }, 
        { estado: 'Veracruz de Ignacio de la Llave', clave:  'VZ' },
        { estado: 'Yucatán', clave:  'YN' }, 
        { estado: 'Zacatecas', clave:  'ZS' }
    ];
    
    const entidad_federativa = entidades_federativas.find( element => { return element.clave === clave });

    return entidad_federativa;
}